import React from 'react';
import {answersFor} from 'records/Scorecard';
import classNames from 'classnames';
import AnswerBubble from 'components/pure/utils/AnswerBubble';
import './ScorecardAnswerBubbles.styl';

export default class ScorecardAnswerBubbles extends React.Component {
  static defaultProps = {
    // TODO Remove this once the key property is removed from scorecards
    selectKey: 'key',
  };

  render() {
    const {
      scoringScheme,
      question,
      answer,
      extraWide,
      onSelectAnswer,
      selectKey,
      disabled,
      isCoaching,
    } = this.props;

    const answerButtons = answersFor(scoringScheme);

    return (
      <div className={classNames('answer-bubbles', extraWide && 'extra-wide')}>
        {answerButtons.map((button, i) => (
          <AnswerBubble
            disabled={disabled}
            answer={answer}
            isSelected={answer === button[selectKey]}
            button={button}
            extraWide={extraWide}
            onSelect={() => onSelectAnswer(question && question.id, button[selectKey])}
            key={i}
            grayBackground={isCoaching}
          />
        ))}
      </div>
    );
  }
}
